import React from "react";
import {
  FaBullseye,
  FaUserShield,
  FaLayerGroup,
  FaHandHoldingUsd,
  FaBusinessTime,
} from "react-icons/fa";
const features = [
  {
    icon: <FaBullseye />,
    title: "Result-Driven Approach",
  },
  {
    icon: <FaUserShield />,
    title: "Expert & Creative Team",
  },
  {
    icon: <FaLayerGroup />,
    title: "Customized Solutions",
  },
  {
    icon: <FaHandHoldingUsd />,
    title: "Affordable Pricing",
  },
  {
    icon: <FaBusinessTime />,
    title: "On-Time Delivery",
  },
];

const WhyChoose = () => {
  return (
    <section className="w-full bg-gradient-to-b from-gray-100 to-white py-16 px-4 sm:px-6 lg:px-16">
      
      {/* Heading */}
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800">
          Why Choose Us
        </h2>
        <p className="text-gray-500 mt-3 text-sm sm:text-base">
          We deliver quality, performance & trust
        </p>

        <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto mt-4 rounded-full"></div>
      </div>

      {/* Grid */}
      <div className="
        grid 
        grid-cols-2 
        sm:grid-cols-3 
        md:grid-cols-5 
        gap-10 
        justify-items-center
      ">
        
        {features.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center group"
          >
            
            {/* Advanced Circle */}
            <div className="
              relative
              w-28 h-28 
              sm:w-32 sm:h-32 
              md:w-36 md:h-36 
              lg:w-40 lg:h-40 
              rounded-full
              flex items-center justify-center
              text-white text-3xl sm:text-7xl
              bg-gradient-to-br from-[#f99728] to-[#f99728]
              shadow-[0_10px_30px_rgba(59,130,246,0.5)]
              group-hover:scale-110
              transition duration-500
            ">
              
              {/* Glow Ring */}
              <div className="
                absolute inset-0 rounded-full
                border-4 border-blue-200
                opacity-40
                group-hover:scale-125
                transition duration-500
              "></div>

              {item.icon}
            </div>

            {/* Title */}
            <p className="
              mt-7
              text-sm sm:text-base 
              font-semibold 
              text-gray-700 
              max-w-[190px]
              leading-snug
            ">
              {item.title}
            </p>

          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;